(function(){
  var SKIP={SCRIPT:1,STYLE:1,TEXTAREA:1,INPUT:1,SUP:1,NOSCRIPT:1,CODE:1,PRE:1,SVG:1,OPTION:1,TITLE:1};
  function fix(root){
    if(!root) return;
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
      if(n.nodeValue.indexOf('®')<0) return NodeFilter.FILTER_REJECT;
      var p=n.parentNode; while(p && p.nodeType===1){ if(SKIP[p.nodeName] || (p.classList&&p.classList.contains('fm-reg'))) return NodeFilter.FILTER_REJECT; if(p.isContentEditable) return NodeFilter.FILTER_REJECT; p=p.parentNode; }
      return NodeFilter.FILTER_ACCEPT;}});
    var nodes=[],n; while((n=w.nextNode())) nodes.push(n);
    nodes.forEach(function(t){
      var parts=t.nodeValue.replace(/®\s+(?=[-‑–])/g,'®').split('®');
      if(parts.length<2) return;
      var frag=document.createDocumentFragment();
      parts.forEach(function(s,i){
        if(s) frag.appendChild(document.createTextNode(s));
        if(i<parts.length-1){ var sup=document.createElement('sup'); sup.className='fm-reg'; sup.textContent='®'; frag.appendChild(sup); }
      });
      t.parentNode.replaceChild(frag,t);
    });
  }
  function run(){ fix(document.body); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  var pending=false;
  new MutationObserver(function(muts){
    if(pending) return; pending=true;
    requestAnimationFrame(function(){ pending=false; muts.forEach(function(m){ m.addedNodes && m.addedNodes.forEach(function(nd){ if(nd.nodeType===1) fix(nd); else if(nd.nodeType===3 && nd.parentNode) fix(nd.parentNode); }); }); });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();